<h3 class="flex">
  <span>Select the format of export</span>
</h3>

<div class="flex flex-start gap-4 flex-row mt-4">
  <div
    class="selection__box flex flex-col gap-3 flex-grow"
    [class.selection__box-selected]="exportType === ExportType.Single"
    (click)="updateExportType(ExportType.Single)">
    <div class="flex">
      <strong class="flex">Single file</strong>
    </div>
    <div class="text-xs">A single CSV file including all your data.</div>
  </div>

  <div
    fxFlex
    class="selection__box flex flex-col gap-3"
    [class.selection__box-selected]="exportType === ExportType.Multiple"
    (click)="updateExportType(ExportType.Multiple)">
    <div class="flex">
      <strong class="flex">Multiple files</strong>
    </div>

    <div class="text-xs">Multiple CSV files in a ZIP file, one file for each property</div>
  </div>
</div>

<div class="flex flex-start flex-row mt-4 -ml-4" *ngIf="!shouldHideIncludeKPIs">
  <hospitable-checkbox
    [checked]="includeKPIs"
    (change)="includeKPIs = $event"
    [label]="'Include Key Performance Indicators'"></hospitable-checkbox>
</div>

<div class="flex flex-row mt-4 text-sm" *ngIf="rowCount && email">
  <span class="flex flex-start justify-items-start items-start">
    <img class="mt-0.5 mr-1" src="./assets/icons/details-grey.svg" height="20" width="20" />

    <span>
      A CSV file including
      <strong>{{ rowCount }}</strong>
      rows will be sent to
      <strong>{{ email }}</strong>
      . It will take a few minutes to generate.
    </span>
  </span>
</div>

<div class="flex mt-4 flex-row-reverse">
  <sbnb-button [label]="'Send'" (clicked)="closeDialog()"></sbnb-button>
</div>
